// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.admin-menu[data-v-45a3a857] {\n  margin-bottom: 0.3rem;\n}\n.list-group-item[data-v-45a3a857]:first-child,\n.list-group-item[data-v-45a3a857]:last-child {\n  border-radius: 0;\n}\n.list-group-item[data-v-45a3a857] {\n  border-left: 0;\n  border-right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
